import * as actions from "./actionsTypes";

const initialData = {
  loadingEmployeeCompetency: false,
  loadingEmployeeCompetencyById: false,
  saveLoadingEmployeeCompetency: false,
  employeeCompetenciesLength: 0,
  employeeCompetencies: [],
  employeeCompetency: {},
  employeeCompetencyError: "",
  formErrorEmployeeCompetency: "",

  loadingBossCompetency: false,
  loadingBossCompetencyById: false,
  saveLoadingBossCompetency: false,
  bossCompetenciesLength: 0,
  bossCompetencies: [],
  bossCompetency: {},
  bossCompetencyError: "",
  formErrorBossCompetency: "",
};

export default function EvaluationCompetencyReducer(state = initialData,action) {
  switch (action.type) {

    //competencias del empleado
    case actions.LOADING_EMPLOYEE_COMPETENCY:
      return { ...state, loadingEmployeeCompetency: action.payload };
    case actions.LOADING_EMPLOYEE_COMPETENCY_BY_ID:
      return { ...state, loadingEmployeeCompetencyById: action.payload };
    case actions.SAVE_LOADING_EMPLOYEE_COMPETENCY:
      return { ...state, saveLoadingEmployeeCompetency: action.payload };
    case actions.GET_EMPLOYEE_COMPETENCY:
      return {
        ...state,
        employeeCompetencies: action.payload.employeeCompetencies,
        employeeCompetenciesLength: action.payload.employeeCompetenciesLength,
      };
    case actions.GET_EMPLOYEE_COMPETENCY_BY_ID:
      return {
        ...state, employeeCompetency: action.payload
      };
    case actions.FORM_FAIL_EMPLOYEE_COMPETENCY:
      return { ...state, formErrorEmployeeCompetency: action.payload };
    case actions.EMPLOYEE_COMPETENCY_FAIL:
      return { ...state, employeeCompetencyError: action.payload };

      

    //competencias del jefe
    case actions.LOADING_BOSS_COMPETENCY:
      return { ...state, loadingBossCompetency: action.payload };
    case actions.LOADING_BOSS_COMPETENCY_BY_ID:
      return { ...state, loadingBossCompetencyById: action.payload };
    case actions.SAVE_LOADING_BOSS_COMPETENCY:
      return { ...state, saveLoadingBossCompetency: action.payload };
    case actions.GET_BOSS_COMPETENCY:
      return {
        ...state,
        bossCompetencies: action.payload.bossCompetencies,
        bossCompetenciesLength: action.payload.bossCompetenciesLength,
      };
    case actions.GET_BOSS_COMPETENCY_BY_ID:
      return {
        ...state, bossCompetency: action.payload
      };
    case actions.FORM_FAIL_BOSS_COMPETENCY:
      return { ...state, formErrorBossCompetency: action.payload };
    case actions.BOSS_COMPETENCY_FAIL:
      return { ...state, bossCompetencyError: action.payload };
    default:
      return state;
  }
}
